import { render, staticRenderFns } from "./CommercialClaimForm.vue?vue&type=template&id=916d68f8&scoped=true&"
import script from "./CommercialClaimForm.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916d68f8",
  null
  
)

export default component.exports